import React, { useRef } from "react";
import View from "../../assets/img/eye.svg";
import Sound from "../../assets/img/sound.svg";
import Calendar from "../../assets/img/calendar-color.svg";
import StatusCheck from "../../assets/img/status-check.svg";
import Question from "../../assets/img/question-mark.svg";
import Ellipse from "../../assets/img/ellipse-1.svg";
import ResponsiveVoice from "responsivevoice";

import { Col, Row } from "react-bootstrap";
import { handleTextToSpeech, handleimageUrl } from "../../utils/ApiFunctions";
import { useNavigate } from "react-router-dom";
import ReactAudioPlayer from "react-audio-player";
import { useLocalization } from "../Localization/Localization";

export const SubjectiveQuestion = ({ questiondata, callback, questions }) => {
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const { t } = useLocalization();
  return (
    <div>
      <div className="ques-type type-1">
        {/* <h3>
          <i>
            <img
              src={Sound}
              onClick={() => handleTextToSpeech(questiondata?.title)}
            />
          </i>{" "}
          {questiondata?.title}
        </h3> */}
        <Row>
          <Col md={12}>
            {questiondata?.type == "writtenQuestion" ||
            questiondata?.type == "completeTheSentence" ||
            questiondata?.type == "completeTheWord" ? (
              <h3>
                <i>
                  <img
                    src={Sound}
                    onClick={() => handleTextToSpeech(questiondata?.title)}
                  />
                </i>{" "}
                {questiondata?.title}
              </h3>
            ) : questiondata?.type == "voiceOnly" ? (
              <>
                <h3>
                  <i>
                    <img
                      src={Sound}
                      onClick={() => handleTextToSpeech(questiondata?.title)}
                    />
                  </i>{" "}
                  {questiondata?.title}
                </h3>
                <div className="audio-plyer">
                  <audio controlsList="nodownload" controls>
                    <source
                      src={handleimageUrl(questiondata?.mediaFile)}
                      controls
                    />
                  </audio>
                </div>
              </>
            ) : questiondata?.type == "videoWithQuestion" ? (
              <Col md={12}>
                <>
                  <h3>
                    <i>
                      <img
                        src={Sound}
                        onClick={() => handleTextToSpeech(questiondata?.title)}
                      />
                    </i>{" "}
                    {questiondata?.title}
                  </h3>
                  <div className="q-video">
                    <iframe
                      src={handleimageUrl(questiondata?.mediaFile)}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                    {/* <video controls poster={handleimageUrl(questiondata?.mediaFile)} width="600">
                      <source  src={handleimageUrl(questiondata?.mediaFile)} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video> */}
                  </div>
                </>
              </Col>
            ) : questiondata?.type == "photoWithQuestion" ? (
              <>
                <h3>
                  <i>
                    <img
                      src={Sound}
                      onClick={() => handleTextToSpeech(questiondata?.title)}
                    />
                  </i>{" "}
                  {questiondata?.title}
                </h3>
                <div className="question-image">
                  <img src={handleimageUrl(questiondata?.mediaFile)} />
                </div>
              </>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row className="mx-5 mt-4">
          <Col md={6}>
            <div className="form-group">
              <input
                type="text"
                placeholder="answer"
                readOnly
                className="form-control"
                value={questiondata?.answer}
              />
            </div>
          </Col>

          <Col md={12} className="text-end mt-5">
            <button className="btn-btn-primary" onClick={callback}>
              {" "}
              {t("next_btn_txt")}
            </button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SubjectiveQuestion;
